import {FeatureNames, UserConfig} from "app/common/services/current-user/models/UserConfig"

export class CurrentUser {
    private constructor(private config: UserConfig) {

    }

    public get id(): number {
        return this.config.id
    }

    public hasFeature(feature: FeatureNames): boolean {
        return this.config.features[feature] != null
    }

    public get stripeId(): string {
        return this.config.stripePublishableKey
    }

    public static create(config: UserConfig): CurrentUser {
        return new CurrentUser(config)
    }
}
